<template>
  <MobileServiceOverview
    class="education-view"
    v-bind="educationOverview"
    :hero-image="educationHeroImage"
  />
</template>

<script>
import MobileServiceOverview from '@/components/content/MobileServiceOverview.vue'
import educationHeroImage from '@/assets/shared/images/service-overview-mobile-hero.webp'

export default {
  name: 'EducationView',
  components: {
    MobileServiceOverview
  },
  data() {
    return {
      educationHeroImage,
      educationOverview: {
        eyebrow: '智谷教育',
        title: '三擎驱动，构建全链路教育生态',
        summary: '聚焦前沿智能技术，以工业真实场景连接教学、实践与科研，推动产、学、研、用深度融合。',
        metrics: [
          { value: '3大', label: '教育业务板块' },
          { value: '3类', label: '场景孪生体系' },
          { value: '6项', label: '高校项目案例' }
        ],
        highlights: [
          {
            kicker: '教学实验',
            title: '工业能力融入课堂',
            description: '融合工业软件、真实数据与先进技术，并通过微型场景和定制实验设备支撑实践教学。'
          },
          {
            kicker: '实践实习',
            title: '沉浸式行业场景体验',
            description: '以实习场景孪生连接真实业务流程，让安全教育全过程可记录、可追溯。'
          },
          {
            kicker: '课题科研',
            title: '真实数据辅助科研',
            description: '建设高质量工业数据样本集，为工业场景智能算法训练和课题研究提供支撑。'
          },
          {
            kicker: '产学研用',
            title: '促进技术成果转化',
            description: '联合高校共建研发基地，以赛事、科研和区域科普服务推动教育与产业协同发展。'
          }
        ]
      }
    }
  }
}
</script>
